import { create } from 'zustand'

interface ILoaderStore {
  quotesLoading: boolean
  setQuotesLoading: (loading: boolean) => void
}

export const loaderStore = create<ILoaderStore>((set) => ({
  quotesLoading: false,
  setQuotesLoading: (loading: boolean) => set({ quotesLoading: loading }),
}))

interface IOptionsLoaderStore {
  loading: boolean
  setOptionsLoading: (loading: boolean) => void
}

export const optionsloaderStore = create<IOptionsLoaderStore>((set) => ({
  loading: false,
  setOptionsLoading: (loading: boolean) => set({ loading }),
}))
